import React, { useEffect, useState } from 'react';
import AdminApi from './AdminApi';

const AdminEmailPage = ({ currentMenu, clickChangeMenu }) => {
    const [emails, setEmails] = useState([]);
    const [subscribes, setSubscribes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedEmail, setSelectedEmail] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        Promise.all([AdminApi.getEmails(), AdminApi.getEmailSubscribes()])
            .then(([emailsData, subscribesData]) => {
                setEmails(emailsData);
                setSubscribes(subscribesData);
            })
            .catch(err => console.error("Error fetching emails:", err))
            .finally(() => setIsLoading(false));
    }, []);

    const formatDate = (isoDateString) => {
        if (!isoDateString) return "N/A";
        const date = new Date(isoDateString);
        return date.toLocaleDateString('vi-VN') + ' ' + date.toLocaleTimeString('vi-VN');
    };

    const handleShowDetail = (email) => {
        setSelectedEmail(email);
        setShowModal(true);
        if (!email.read) {
            AdminApi.updateEmail(email.id, { ...email, read: true })
                .then(() => {
                    setEmails(prevEmails => prevEmails.map(e => 
                        e.id === email.id ? { ...e, read: true } : e
                    ));
                })
                .catch(err => console.error("Error updating email read status:", err));
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedEmail(null);
    };

    return (
        <div className="social-box">
            <h3 className="page-title">Quản lý Email & Đăng ký</h3>
            <div className="header" style={{ marginBottom: '15px' }}>
                <div className="input-append" style={{ marginBottom: 0 }}>
                    <input className="span8" id="appendedInputButton" type="text" placeholder="Tìm theo tiêu đề" style={{ borderRadius: '25px 0 0 25px', paddingLeft: '15px' }} />
                    <button className="btn" type="button" style={{ borderRadius: '0 25px 25px 0' }}><i className="icon-search" /></button>
                </div>
            </div>
            <div className="body">
                <table className="table table-hover table-striped table-bordered">
                    <thead>
                        <tr>
                            <th>Tiêu đề <i className="icon-caret-down" /></th>
                            <th>Người gửi</th>
                            <th>Email người gửi</th>
                            <th>Số điện thoại</th>
                            <th>Ngày nhận <i className="icon-caret-down" /></th>
                            <th>Đã xem</th>
                            <th width="150px"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <tr><td colSpan="7" className="text-center">Đang tải...</td></tr>
                        ) : (
                            emails.map(email => (
                                <tr key={email.id}>
                                    <td style={{ color: '#2891cf' }}>{email.subject}</td>
                                    <td>{email.username}</td>
                                    <td>{email.email}</td>
                                    <td>{email.phone}</td>
                                    <td>{formatDate(email.datesend)}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        <input type="checkbox" checked={email.read || false} readOnly />
                                    </td>
                                    <td>
                                        <a className="btn btn-primary btn-small" href="#" style={{ backgroundColor: '#5bb75b', border: 'none', marginRight: '5px' }} 
                                            onClick={e => { e.preventDefault(); handleShowDetail(email); }}>
                                            Chi tiết
                                        </a>
                                        <a className="btn btn-danger btn-small" href="#" style={{ backgroundColor: '#cc0000', border: 'none' }} onClick={e => e.preventDefault()}>
                                             Xóa
                                        </a>
                                    </td>
                                </tr>
                            ))
                        )}
                        {emails.length === 0 && !isLoading && (
                             <tr><td colSpan="7" className="text-center">Không có dữ liệu</td></tr>
                        )}
                    </tbody>
                </table>

                {subscribes.length > 0 && (
                    <>
                        <h4 style={{marginTop: '40px', color: '#555'}}>Đăng ký nhận tin</h4>
                        <table className="table table-hover table-bordered">
                            <thead>
                                <tr>
                                    <th>Email</th>
                                    <th>Ngày đăng ký</th>
                                    <th>Trạng thái</th>
                                    <th width="100px"></th>
                                </tr>
                            </thead>
                            <tbody>
                                {subscribes.map((item) => (
                                    <tr key={item.id}>
                                        <td><strong>{item.email}</strong></td>
                                        <td>{formatDate(item.subscribeDate)}</td>
                                        <td>
                                            <span className={`label ${item.active ? 'label-success' : 'label-important'}`}>
                                                {item.active ? 'Kích hoạt' : 'Tạm dừng'}
                                            </span>
                                        </td>
                                        <td>
                                            <a className="btn btn-danger btn-small" href="#" onClick={e => e.preventDefault()}>
                                                Xóa
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </>
                )}
            </div>

            {showModal && selectedEmail && (
                <div style={modalOverlayStyle} onClick={handleCloseModal}>
                    <div style={modalStyle} onClick={e => e.stopPropagation()}>
                        <button style={closeButtonStyle} onClick={handleCloseModal}>&times;</button>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', fontSize: '14px', color: '#333' }}>
                            <div style={rowStyle}>
                                <div style={labelStyle}>Tên</div>
                                <div style={valueStyle}>
                                    <strong>{selectedEmail.username}</strong> <span style={{ color: '#2891cf', marginLeft: '5px' }}>{selectedEmail.email}</span>
                                </div>
                            </div>
                            <div style={rowStyle}>
                                <div style={labelStyle}>Ngày nhận</div>
                                <div style={valueStyle}>{formatDate(selectedEmail.datesend)}</div>
                            </div>
                            <div style={rowStyle}>
                                <div style={labelStyle}>Địa chỉ</div>
                                <div style={valueStyle}>{selectedEmail.address || "N/A"}</div>
                            </div>
                            <div style={rowStyle}>
                                <div style={labelStyle}>Số điện thoại</div>
                                <div style={valueStyle}>{selectedEmail.phone}</div>
                            </div>
                            <div style={rowStyle}>
                                <div style={labelStyle}>Tiêu đề</div>
                                <div style={valueStyle}>{selectedEmail.subject}</div>
                            </div>
                            <div style={{ marginTop: '20px', lineHeight: '1.6', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                                {selectedEmail.text}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10000,
};

const modalStyle = {
    backgroundColor: 'white',
    padding: '40px 30px',
    borderRadius: '2px',
    width: '700px',
    maxWidth: '90%',
    maxHeight: '90vh',
    overflowY: 'auto',
    position: 'relative',
    boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
};

const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '15px',
    border: 'none',
    background: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#999',
};

const rowStyle = {
    display: 'flex',
    marginBottom: '5px',
};

const labelStyle = {
    width: '120px',
    textAlign: 'right',
    paddingRight: '20px',
    fontWeight: 'normal',
    color: '#000',
};

const valueStyle = {
    flex: 1,
    color: '#333',
};

export default AdminEmailPage;
